import {
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
  AlertCircleIcon,
} from "@gluestack-ui/themed";
import { IInputError } from "./types";

export const InputError = ({ errorMessage }: IInputError) => {
  if (!errorMessage) return null;

  return (
    <FormControlError>
      <FormControlErrorIcon size="xs" color="$error700" as={AlertCircleIcon} />
      <FormControlErrorText>{errorMessage}</FormControlErrorText>
    </FormControlError>
  );
};
